import { render, staticRenderFns } from "./createSuggestRoutes.vue?vue&type=template&id=311b2898"
import script from "./createSuggestRoutes.vue?vue&type=script&lang=js"
export * from "./createSuggestRoutes.vue?vue&type=script&lang=js"
import style0 from "./createSuggestRoutes.vue?vue&type=style&index=0&id=311b2898&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports